import { Box, Typography } from "@mui/material";

export function getLeagueDisplayName(league) {
  if (typeof league === "string") return league;
  const name = league?.name;
  if (typeof name === "string") return name;
  if (name && name !== league) return getLeagueDisplayName(name);
  return "";
}

export function LeagueDisplay({
  league,
  compact = false,
}) {
  const leagueName = getLeagueDisplayName(league);
  const countryName =
    league?.country?.name || "";

  const countryFlag =
    league?.country?.image_path || "";

  const leagueLogo =
    league?.image_path || "";

  if (compact) {
    return (
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 1,
          minWidth: 0,
          maxWidth: "100%",
          overflow: "hidden",
        }}
      >
        {countryFlag ? (
          <Box
            component="img"
            src={countryFlag}
            alt={countryName}
            title={countryName}
            sx={{
              width: 28,
              height: 20,
              objectFit: "contain",
              flexShrink: 0,
            }}
          />
        ) : null}

        <Typography
          component="span"
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            minWidth: 0,
          }}
        >
          {leagueName}
        </Typography>

        {leagueLogo ? (
          <Box
            component="img"
            src={leagueLogo}
            alt={`${leagueName || "League"} logo`}
            title={leagueName}
            sx={{
              width: 26,
              height: 26,
              objectFit: "contain",
              flexShrink: 0,
            }}
          />
        ) : null}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns:
          "30px minmax(180px, 1fr) 38px",
        alignItems: "center",
        columnGap: 1.25,
        width: "100%",
        minWidth: 310,
      }}
    >
      <Box
        sx={{
          width: 30,
          height: 22,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        {countryFlag ? (
          <Box
            component="img"
            src={countryFlag}
            alt={countryName}
            title={countryName}
            sx={{
              width: 28,
              maxHeight: 20,
              objectFit: "contain",
            }}
          />
        ) : null}
      </Box>

      <Typography
        component="span"
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {leagueName}
      </Typography>

      <Box
        sx={{
          width: 38,
          height: 32,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        {leagueLogo ? (
          <Box
            component="img"
            src={leagueLogo}
            alt={`${leagueName || "League"} logo`}
            title={leagueName}
            sx={{
              width: 30,
              maxHeight: 30,
              objectFit: "contain",
            }}
          />
        ) : null}
      </Box>
    </Box>
  );
}
